import { connect } from "react-redux";

import Actions from "../../Actions/Creators";
import Student from "./Component/Student";
import Phi from "../../Phi/Phi";

const mapStateToProps = (state, ownProps) => ({
  organizationId: JSON.parse(Phi.Storage.getItem("organization"))
    ? JSON.parse(Phi.Storage.getItem("organization"))[0].org_id
    : null,
  studentHeader: state.student.studentHeader,
  studentList: state.student.studentList,
  totalStudent: state.student.totalStudent,
  pdfContent: state.student.pdfContent,
  currentProgram: state.organization.currentProgram,
  x: state.organization.programs,
  startNodeMap: state.organization.startNodeMap,
  classes: state.organization.classes,
  boardingTypes: state.organization.boardingTypes,
  history: state.organization.history,
  newstudent: state.student.newstudent,
  assessmentStatus: state.student.assessmentStatus,
});

const mapDispatchToProps = (dispatch) => ({
  fetchStudentList: (payload) => dispatch(Actions.fetchStudentList(payload)),
  getProgramByOrganization: (organization_id) =>
    dispatch(Actions.getProgramByOrganization(organization_id)),
  getStudentReport: (reportType, config) =>
    dispatch(Actions.getStudentReport(reportType, config)),
  getBulkStudentReport: (reportType, config) =>
    dispatch(Actions.getBulkStudentReport(reportType, config)),

  setLoader: () => dispatch(Actions.setLoader()),
  unsetLoader: () => dispatch(Actions.unsetLoader()),
  getStudentBoardingType: (organizationId) =>
    dispatch(Actions.getStudentBoardingType(organizationId)),
  setSelectedStudent: (payload) =>
    dispatch(Actions.setSelectedStudent(payload)),
  changeReportInReducer: (billingId) =>
    dispatch(Actions.changeReportInReducer(billingId)),
  fetchStudentAssessmentStatus: (header) =>
    dispatch(Actions.fetchStudentAssessmentStatus(header)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Student);
